import { ChangeEvent, useCallback, useState } from 'react'

export function useHandlers() {
  const [showEmpty, setShowEmpty] = useState(false)

  const toggleShowEmpty = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setShowEmpty(event.target.checked)
    },
    [setShowEmpty],
  )

  return {
    showEmpty,
    toggleShowEmpty,
  }
}
